import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Degrees: ConvertableUnit = {
  label: "Degrees",
  toStandardUnit: deg => deg,
  toThisUnit: deg => deg
};
export const Radians: ConvertableUnit = {
  label: "Radians",
  toStandardUnit: rads => (rads * 180) / Math.PI,
  toThisUnit: deg => (deg * Math.PI) / 180
};

const unitList = [Degrees, Radians];
export const AngleUnits = {
  Degrees,
  Radians,
  options: buildOptions(unitList)
};
